import type { ReactNode } from 'react';

interface WebhookDeliveryDetailFieldProps {
    label: string;
    children: ReactNode;
}

export function WebhookDeliveryDetailField({
    label,
    children,
}: WebhookDeliveryDetailFieldProps) {
    return (
        <div className="flex min-w-0 items-baseline gap-3 text-sm">
            <span className="w-24 shrink-0 text-grey-300">{label}</span>
            <div className="min-w-0 flex-1">{children}</div>
        </div>
    );
}
